import Link from "next/link";
import NxtImage from "@sharedComponents/image";

import stadiumLogo from "@images/svg/stadium-logo.svg";

const Error = () => (
  <div className="d-flex align-items-center justify-content-center vh-100">
    <section className="text-center">
      <div className="container">
        <Link href={"/"} passHref>
          <div className="p-3 mb-5 position-relative cursor-pointer">
            <NxtImage src={stadiumLogo} layout="fill" />
          </div>
        </Link>

        <h2 className="jumbotron-heading text-theme-primary">Something went wrong!</h2>
        <p className="lead text-muted mb-5">
          Our team has been notified, meanwhile you may refresh the page or try again later.
        </p>
      </div>
    </section>
  </div>
);

export default Error;
